// Frontend/src/components/common/Footer.jsx
import React from 'react';
import { Heart } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white border-t border-gray-200 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="flex items-center gap-2 text-sm text-gray-600">
            <span>© {currentYear} Employee Portal. All rights reserved.</span>
          </div>
          <div className="flex items-center gap-4 text-sm text-gray-600">
            <a
              href="#"
              className="hover:text-indigo-600 transition-colors"
              onClick={(e) => e.preventDefault()}
            >
              Privacy Policy
            </a>
            <span className="text-gray-300">|</span>
            <a
              href="#"
              className="hover:text-indigo-600 transition-colors"
              onClick={(e) => e.preventDefault()}
            >
              Terms of Service
            </a>
            <span className="text-gray-300">|</span>
            <a
              href="#"
              className="hover:text-indigo-600 transition-colors"
              onClick={(e) => e.preventDefault()}
            >
              Support
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;





